import React, { FC } from "react";

import { Fa } from "./Icon";
import { formatDate } from "i18n";

const optionsIntl: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "long",
  day: "2-digit",
  hour: "numeric",
  minute: "numeric",
  second: "numeric"
};

/**
 * Composant Hour permet d'afficher la date & l'heure avec une mise à jour régulière (toutes les secondes)
 */
const Hour: FC = () => {
  const [date, setDate] = React.useState(new Date());

  React.useEffect(() => {
    const interval = setInterval(() => {
      setDate(new Date());
    }, 1000);

    return function cleanup() {
      clearInterval(interval);
    };
  }, []);

  return (
    <span style={{ marginRight: "1em" }}>
      <span className="icon" style={{ paddingRight: 10 }}>
        <Fa icon={["fad", "clock"]} color="#dedede" />
      </span>
      {formatDate(date, optionsIntl)}
    </span>
  );
};

export default Hour;
